import update from 'immutability-helper'
import {
  PROJECT_FETCH_ERROR,
  PROJECT_FETCH_SUCCESS,
  PROJECT_FETCH,
  PROJECT_PROFILE_FETCH,
  PROJECT_PROFILE_RESET,
  PROJECT_FETCH_FILES,
  PROJECT_UPDATE_MILESTONE_TASK,
  PROJECT_SET_MILESTONE_STATUS,
  PROJECTS_UPDATE_ACTIVITY_FILTERS,
  PROJECT_DEAL_FILTER_ALL,
  PROJECT_PERSON_FILTER_ALL,
  PROJECT_COMPANY_FILTER_ALL
} from 'Projects/constants'
import { ACTIVITY_ANY_TIME, GENERIC_FILTER_ANY } from 'Profiles/constants/activities'
import { FETCH_STATES } from 'Profiles/constants/fetch'

export const initialState = {
  projectId: null,
  project: {},
  fetching: FETCH_STATES.fetching,
  // Activity filters state
  activityFilters: {
    dateFilter: ACTIVITY_ANY_TIME,
    activityTabFilters: {
      [GENERIC_FILTER_ANY]: true
    },
    emailTabFilters: {
      [GENERIC_FILTER_ANY]: true,
      Email: false,
      'Trackable Email Action': false
    },
    searchQuery: '',
    currentTab: 'ALL',
    // PRO-247 — per-entity narrowing for the activity feed.
    dealFilter: PROJECT_DEAL_FILTER_ALL,
    personFilter: PROJECT_PERSON_FILTER_ALL,
    companyFilter: PROJECT_COMPANY_FILTER_ALL
  },
  // Files state
  files: [],
  filesFetching: FETCH_STATES.fetching,
  fileSort: { field: 'created_at', direction: 'desc' },
  fileFilters: {
    fileTitle: '',
    fileOwner: [],
    fileUpdatedAt: {},
    fileSize: {},
    fileTags: []
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PROJECT_PROFILE_RESET:
      return { ...initialState }
    case PROJECT_PROFILE_FETCH:
      return { ...initialState, projectId: action.payload.projectId }
    case PROJECT_FETCH:
      return { ...state, projectId: action.payload.projectId, fetching: FETCH_STATES.fetching }
    case PROJECT_FETCH_SUCCESS:
      return {
        ...update(state, { project: { $set: action.payload } }),
        fetching: FETCH_STATES.fetchSuccess
      }
    case PROJECT_FETCH_ERROR:
      return { ...initialState, fetching: { ...FETCH_STATES.fetchError, fetchError: action.payload } }

    // Files reducers
    case PROJECT_FETCH_FILES:
      return { ...state, filesFetching: FETCH_STATES.fetching }
    case 'PROJECTS_LOAD_FILES':
      return { ...state, files: action.payload, filesFetching: FETCH_STATES.fetchSuccess }
    case 'PROJECTS_CREATE_FILE':
      return { ...state, files: [action.payload, ...state.files] }
    case 'PROJECTS_UPDATE_FILE':
      return { ...state, files: state.files.map((file) => file.id === action.payload.id ? action.payload : file) }
    case 'PROJECTS_DELETE_FILE':
      return { ...state, files: state.files.filter(file => file.id !== action.payload.id) }
    case 'PROJECTS_SORT_FILES':
      return { ...state, fileSort: action.payload }
    case 'PROJECTS_FILTER_FILES':
      return { ...state, fileFilters: action.payload }

    // Update a task within a milestone (e.g., toggle completion)
    case PROJECT_UPDATE_MILESTONE_TASK: {
      const { milestoneId, taskId, updates } = action.payload
      const milestones = state.project.project_milestones || []
      const updatedMilestones = milestones.map(milestone => {
        if (milestone.id !== milestoneId) return milestone
        const updatedTasks = (milestone.tasks || []).map(task => {
          if (task.id !== taskId) return task
          return { ...task, ...updates }
        })
        return { ...milestone, tasks: updatedTasks }
      })
      return update(state, {
        project: {
          project_milestones: { $set: updatedMilestones }
        }
      })
    }

    // Set a milestone's status (optimistic update / revert, driven by the saga)
    case PROJECT_SET_MILESTONE_STATUS: {
      const { milestoneId, status } = action.payload
      const milestones = state.project.project_milestones || []
      const updatedMilestones = milestones.map(milestone => {
        if (milestone.id !== milestoneId) return milestone
        return { ...milestone, status, project_milestone_status_id: status ? status.id : null }
      })
      return update(state, {
        project: {
          project_milestones: { $set: updatedMilestones }
        }
      })
    }

    // Activity filters
    case PROJECTS_UPDATE_ACTIVITY_FILTERS:
      return { ...state, activityFilters: { ...state.activityFilters, ...action.payload } }

    default:
      return state
  }
}
